import React from 'react'
import { useMediaQuery } from '../../../hooks/useMediaQuery'
import style from './style.module.scss'
import ExternalSelect from '../../components/ExternalSelect'
import { menuItemParams } from '../../../types'
import clsx from 'clsx'

type menuTopHeaderParams = {
    menu: menuItemParams[]
}

const MenuTopHeader: React.FC<menuTopHeaderParams> = ({ menu }) => {
    const laptop = useMediaQuery('(max-width: ' + style.laptopBreakpoint + ')')
    const mobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')')

    if (menu === undefined) {
        return null
    }

    if (laptop && !mobile) {
        return <ExternalSelect placeholder={'Accès rapide'} items={menu} />
    }

    return (
        <ul className={style.menu}>
            {menu.map((item) => (
                <li key={item.ID}>
                    <a
                        href={item.url}
                        target={item.target || undefined}
                        className={clsx(item.classes)}
                    >
                        {item.title}
                    </a>
                </li>
            ))}
        </ul>
    )
}

export default MenuTopHeader
